import { registerTab } from "lib/@components/tabs"
import { Lazy } from "lib/make-lazy"

registerTab({
    tab: "sfg20AdminTabs",
    id: "customerSupportEmail",
    title: "Customer Support Emails",
    demands: "admin",
    content: (
        <Lazy priority={10000} importer={() => import("./customer-support-email")} extract="CustomerSupportEmail" />
    ),
})
